module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-search"
  }, [_c('div', {
    staticClass: "search-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.painterName),
      expression: "painterName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "",
      "id": "J_SearchPlaceholder"
    },
    domProps: {
      "value": (_vm.painterName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.painterName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search-btn"
  }, [_c('button', {
    on: {
      "click": _vm.searchKeyWord
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-611241c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search.vue
// module id = 133
// module chunks = 1